import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { CallDirection } from "stores/ApplicationFilters/Filters/CallDirection";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const CallDirectionsChips = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    return applicationFiltersStore.callDirections.map((callDirection) => (
        <AppliedFilterChip
            key={callDirection}
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() =>
                applicationFiltersStore.toggleCallDirection(callDirection)
            }
        >
            {CallDirection.toString(callDirection)}
        </AppliedFilterChip>
    ));
});
